import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CONSENT_KEY = "analyticsConsent";

export default function RouteTracker({ children }) {
  const location = useLocation();

  useEffect(() => {
    if (
      !location.pathname.startsWith("/logout") &&
      !location.pathname.startsWith("/login")
    ) {
      const fullPath = location.pathname + location.search;
      const currentStoredPath = localStorage.getItem("redirAfterLogin");

      if (currentStoredPath !== fullPath) {
        localStorage.setItem("redirAfterLogin", fullPath);
      }
    }

    if (
      window.gtag &&
      localStorage.getItem(CONSENT_KEY) === "accepted"
    ) {
      window.gtag("event", "page_view", {
        page_path: location.pathname,
      });
    }
  }, [location.pathname]);

  return <>{children}</>;
}
